<template>
  <div class="header">
    <div class="header__desktop">
      <HeaderDesktop
        :nav-items="navItems"
        :is-bg-hidden="isHeaderBgHidden"
        :is-header-hidden="isHeaderHidden"
      />
    </div>
    <div class="header__mobile">
      <HeaderMobile
        :nav-items="navItems"
        :is-bg-hidden="isHeaderBgHidden"
        :is-header-hidden="isHeaderHidden"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  const { status, getSession } = useAuth();

  const navItems = computed(() => [
    {
      title: "About",
      url: "/about",
    },
    {
      title: "Careers",
      url: "/careers/",
    },
    {
      title: "News",
      url: "/news",
    },
    {
      title: "Contact Us",
      url: "/contact-us",
    },
    {
      title: "Admin",
      url: "/admin/",
      hidden: status.value !== "authenticated",
    },
  ]);

  const isHeaderHidden = ref(false);
  const isHeaderBgHidden = ref(true);
  onMounted(() => {
    getSession();

    let prevScrollPos = window.pageYOffset;
    if (prevScrollPos !== 0) isHeaderBgHidden.value = false;

    window.onscroll = () => {
      const currentScrollPos = window.pageYOffset;
      if (prevScrollPos > currentScrollPos || currentScrollPos <= 0) {
        if (currentScrollPos === 0) isHeaderBgHidden.value = true;
        else isHeaderBgHidden.value = false;

        isHeaderHidden.value = false;
      } else {
        isHeaderHidden.value = true;
      }
      prevScrollPos = currentScrollPos;
    };
  });
</script>

<style scoped lang="scss">
  .header {
    font-family: var(--font-family-main);

    &__desktop {
      display: block;
      @media (max-width: $lg) {
        display: none;
      }
    }

    &__mobile {
      display: none;
      @media (max-width: $lg) {
        display: block;
      }
    }
  }

  .header-menu-slide-enter-active,
  .header-menu-slide-leave-active {
    transition: all 200ms ease-out;
  }

  .header-menu-slide-enter-from,
  .header-menu-slide-leave-to {
    transform: translateY(-100%);
  }
</style>
